import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Container, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import { createApplicationAction } from "../../../redux/actions/ApplicationAction";
import notify from "../../../Notifcation";
import { useNavigate } from "react-router-dom";

const Build = () => {
  const [desc, setdesc] = useState("");
  const [Nationalid, setNationalid] = useState("");
  const [Power, setPower] = useState("");
  const [Titledeed, setTitledeed] = useState("");
  const [Engineeringdraw, setEngineeringdraw] = useState([]);
  const [Coastcalcfoarm, setCoastcalcfoarm] = useState("");
  const [Insurancypolicy, setInsurancypolicy] = useState("");
  const [Checksegel, setChecksegel] = useState("");
  const [Buildimg, setBuildimg] = useState("");
  const [Mamoordar, setMamoordar] = useState("");
  const [Engreport, setEngreport] = useState("");
  const [Hadm, setHadm] = useState("");

  const [Busnessvalid, setBusnessvalid] = useState("");
  const [AnInsure, setAnInsure] = useState("");
  const [Arthimiticnote, setArthimiticnote] = useState("");

  const [ChoseServ, setChoseServ] = useState("");
  const [ChoseServSub, setChoseServSub] = useState("");

  const [Others, setOthers] = useState([]);
  const navegate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [isPress, setisPress] = useState(false);
  const handleFileChangeNational = (e) => {
    // Convert FileList to Array
    const files = Array.from(e.target.files);
    setNationalid(files);
  };
  const handleFileChangeEngdraw = (e) => {
    // Convert FileList to Array
    const files = Array.from(e.target.files);
    setEngineeringdraw(files);
  };
  const handleFileChangeOther = (e) => {
    // Convert FileList to Array
    const files = Array.from(e.target.files);
    setOthers(files);
  };
  const handlesubmit = async (e) => {
    e.preventDefault();
    if (Nationalid === "" || Titledeed === "") {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    setisPress(true);
    const formData = new FormData();
    formData.append("application_type", 7);
    formData.append("local_type", 1);
    formData.append("local_category", ChoseServ);
    formData.append("local_type_details", ChoseServSub);
    formData.append("local_details", desc);
    formData.append("title_deed", Titledeed);
    formData.append("cost_calculation_form", Coastcalcfoarm);
    formData.append("insurance_policy", Insurancypolicy);
    formData.append("business_validity_certificate", Busnessvalid);
    formData.append("insurance_document_construction_drawings", AnInsure);
    formData.append("arithmetic_note", Arthimiticnote);
    formData.append("power_attoreny", Power);
    formData.append("detect_recorders", Checksegel);
    formData.append("property_picture", Buildimg);
    formData.append("tax_certificate", Mamoordar);
    formData.append("final_decision_administrative_authority_demolish", Hadm);
    formData.append("structural_engineer_report", Engreport);
    Nationalid.map((item) => {
      return formData.append("client_national_ids", item);
    });
    Engineeringdraw.map((item) => {
      return formData.append("engineering_drawings", item);
    });
    Others.map((item) => {
      return formData.append("others", item);
    });
    await dispatch(createApplicationAction(formData));
    setLoading(false);
    setisPress(false);
    setdesc("");
    setNationalid("");
    setAnInsure("");
    setInsurancypolicy("");
    setArthimiticnote("");
    setBusnessvalid("");
    setChoseServ("");
    setChoseServSub("");
    setPower("");
    setTitledeed("");
    setOthers("");
  };
  const res = useSelector((state) => state.ApplicationReduser.createApp);

  useEffect(() => {
    if (loading === false) {
      setTimeout(() => setLoading(true), 1500);
      if (res) {
        if (res.status === 201 || res.status === 200) {
          if (res.data) {
            notify(res.data.message, "success");
            setTimeout(() => {
              navegate("/user/requestsuser");
            }, 3000);
          }
        } else if (res.status !== 201 || res.status !== 200) {
          if (res.data) {
            notify(res.data.message, "error");
          } else {
            notify("حدثة مشكلة حاول مرة اخرى", "error");
          }
        }
      }
    }
  }, [loading]);
  return (
    <Container>
      {" "}
      <h3 className="text-center mb-3 mt-3">خدمات البناء</h3>
      <div className="inputs-container">
        <div className="inp-container">
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              {
                <Typography>
                  نوع الخدمة
                  <span style={{ color: "red", fontSize: "21px" }}>*</span>
                </Typography>
              }
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label={
                <Typography>
                  نوع الخدمة
                  <span style={{ color: "red", fontSize: "21px" }}>*</span>
                </Typography>
              }
              value={ChoseServ}
              onChange={(e) => {setChoseServ(e.target.value)
                setChoseServSub("")}}
            >
              <MenuItem value={1}>خدمة استخراج تراخيص البناء</MenuItem>
              <MenuItem value={2}>
                طلب استخراج بيان بصلاحية الموقع من الناحية التخطيطية
              </MenuItem>
              <MenuItem value={3}>طلب قيد اتحاد شاغلين</MenuItem>
              <MenuItem value={4}>طلب معاينة عقارات آيلة للسقوط</MenuItem>
              <MenuItem value={5}>
                طلب خدمة الحصول على قرار هدم منشأة آيلة للسقوط
              </MenuItem>
              <MenuItem value={6}>
                طلب خدمة الحصول على ترميم منشأة آيلة للسقوط
              </MenuItem>
              <MenuItem value={7}>طلب شهادة باتمام خدمة الترميم</MenuItem>
            </Select>
          </FormControl>
        </div>
        {ChoseServ === 1 ? (
          <div className="inp-container">
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">
                {
                  <Typography>
                    الأجراء
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label={
                  <Typography>
                    الأجراء
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                value={ChoseServSub}
                onChange={(e) => setChoseServSub(e.target.value)}
              >
                <MenuItem value={"construction"}>انشاء</MenuItem>
                <MenuItem value={"amendment"}>تعديل</MenuItem>
                <MenuItem value={"addition"}>اضافة</MenuItem>
                <MenuItem value={"external_finishes"}>تشطيبات خارجية</MenuItem>
                <MenuItem value={"complete"}>استكمال</MenuItem>
                <MenuItem value={"raising"}>تعلية</MenuItem>
              </Select>
            </FormControl>
          </div>
        ) : null}
        {ChoseServ === 4 || ChoseServ === 6 || ChoseServ === 7 ? (
          <>
            <div className="inp-container ">
              <TextField
                label={
                  <Typography>
                    البطاقة الشخصية
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                focused
                inputProps={{
                  multiple: true,
                }}
                type="file"
                onChange={handleFileChangeNational}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={
                  <Typography>
                    سند ملكية الأرض
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                focused
                // inputProps={{
                //   multiple: true,
                // }}
                type="file"
                onChange={(e) => setTitledeed(e.target.files[0])}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"كشف مسجلات لأكثر من عامين"}
                focused
                // inputProps={{
                //   multiple: true,
                // }}
                type="file"
                onChange={(e) => setChecksegel(e.target.files[0])}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"صورة للعقار"}
                focused
                // inputProps={{
                //   multiple: true,
                // }}
                type="file"
                onChange={(e) => setBuildimg(e.target.files[0])}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"شهادة من مأمورية الضرائب"}
                focused
                // inputProps={{
                //   multiple: true,
                // }}
                type="file"
                onChange={(e) => setMamoordar(e.target.files[0])}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"تقرير مهندس انشائي خبرتة لاتقل عن 7 سنوات"}
                focused
                // inputProps={{
                //   multiple: true,
                // }}
                type="file"
                onChange={(e) => setEngreport(e.target.files[0])}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={
                  "وثيقة تأمين بها نسبة من الرسومات الأنشائية معتمدة من المحطة العشرية"
                }
                focused
                // inputProps={{
                //   multiple: true,
                // }}
                type="file"
                onChange={(e) => setAnInsure(e.target.files[0])}
                variant="outlined"
              />
            </div>

            <div className="inp-container ">
              <TextField
                label={"تفاصيل"}
                multiline
                type="text"
                value={desc}
                onChange={(e) => {
                  setdesc(e.target.value);
                }}
                variant="outlined"
              />
            </div>

            <div className="inp-container ">
              <TextField
                label={"اخرى"}
                focused
                inputProps={{
                  multiple: true,
                }}
                type="file"
                onChange={handleFileChangeOther}
                variant="outlined"
              />
            </div>
          </>
        ) : ChoseServ === 5 ? (
          <>
            <div className="inp-container ">
              <TextField
                label={
                  <Typography>
                    البطاقة الشخصية
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                focused
                inputProps={{
                  multiple: true,
                }}
                type="file"
                onChange={handleFileChangeNational}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={
                  <Typography>
                    سند ملكية الأرض
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                focused
                // inputProps={{
                //   multiple: true,
                // }}
                type="file"
                onChange={(e) => setTitledeed(e.target.files[0])}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"كشف مسجلات لأكثر من عامين"}
                focused
                // inputProps={{
                //   multiple: true,
                // }}
                type="file"
                onChange={(e) => setChecksegel(e.target.files[0])}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"صورة للعقار"}
                focused
                // inputProps={{
                //   multiple: true,
                // }}
                type="file"
                onChange={(e) => setBuildimg(e.target.files[0])}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"شهادة من مأمورية الضرائب"}
                focused
                // inputProps={{
                //   multiple: true,
                // }}
                type="file"
                onChange={(e) => setMamoordar(e.target.files[0])}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"تقرير مهندس انشائي خبرتة لاتقل عن 7 سنوات"}
                focused
                // inputProps={{
                //   multiple: true,
                // }}
                type="file"
                onChange={(e) => setEngreport(e.target.files[0])}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"قرار نهائي من الجهة الأدارية بالهدم"}
                focused
                // inputProps={{
                //   multiple: true,
                // }}
                type="file"
                onChange={(e) => setHadm(e.target.files[0])}
                variant="outlined"
              />
            </div>

            <div className="inp-container ">
              <TextField
                label={"تفاصيل"}
                multiline
                type="text"
                value={desc}
                onChange={(e) => {
                  setdesc(e.target.value);
                }}
                variant="outlined"
              />
            </div>

            <div className="inp-container ">
              <TextField
                label={"اخرى"}
                focused
                inputProps={{
                  multiple: true,
                }}
                type="file"
                onChange={handleFileChangeOther}
                variant="outlined"
              />
            </div>
          </>
        ) : (
          <>
            <div className="inp-container ">
              <TextField
                label={
                  <Typography>
                    البطاقة الشخصية
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                focused
                inputProps={{
                  multiple: true,
                }}
                type="file"
                onChange={handleFileChangeNational}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={
                  <Typography>
                    سند ملكية الأرض
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                focused
                // inputProps={{
                //   multiple: true,
                // }}
                type="file"
                onChange={(e) => setTitledeed(e.target.files[0])}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"التوكيل"}
                focused
                // inputProps={{
                //   multiple: true,
                // }}
                type="file"
                onChange={(e) => setPower(e.target.files[0])}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"عدد 3 نسخ من الرسومات الهندسية"}
                focused
                inputProps={{
                  multiple: true,
                }}
                type="file"
                onChange={handleFileChangeEngdraw}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"نموزج حساب التكاليف"}
                focused
                // inputProps={{
                //   multiple: true,
                // }}
                type="file"
                onChange={(e) => setCoastcalcfoarm(e.target.files[0])}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"وثيقة تأمين في حالة بناء اكثر من 4 طوابق"}
                focused
                // inputProps={{
                //   multiple: true,
                // }}
                type="file"
                onChange={(e) => setInsurancypolicy(e.target.files[0])}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"شهادة صلاحية الأعمال للتراخيص موقعة من المهندس"}
                focused
                // inputProps={{
                //   multiple: true,
                // }}
                type="file"
                onChange={(e) => setBusnessvalid(e.target.files[0])}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={
                  "وثيقة تأمين بها نسبة من الرسومات الأنشائية معتمدة من المحطة العشرية"
                }
                focused
                // inputProps={{
                //   multiple: true,
                // }}
                type="file"
                onChange={(e) => setAnInsure(e.target.files[0])}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"نوتة حسابية من مكتب المهندس"}
                focused
                // inputProps={{
                //   multiple: true,
                // }}
                type="file"
                onChange={(e) => setArthimiticnote(e.target.files[0])}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"تفاصيل"}
                multiline
                type="text"
                value={desc}
                onChange={(e) => {
                  setdesc(e.target.value);
                }}
                variant="outlined"
              />
            </div>

            <div className="inp-container ">
              <TextField
                label={"اخرى"}
                focused
                inputProps={{
                  multiple: true,
                }}
                type="file"
                onChange={handleFileChangeOther}
                variant="outlined"
              />
            </div>
          </>
        )}
        <div className="inp-container "></div>
        <div className="inp-container "></div>
      </div>
      {isPress && loading ? (
        <button className="buttonadd">
          <Spinner />
        </button>
      ) : (
        <button className="buttonadd" onClick={handlesubmit}>
          {" "}
          استكمال الطلب
        </button>
      )}
      <ToastContainer />
    </Container>
  );
};

export default Build;
